import { Skeleton } from './Skeleton'
import { space, device, Card, Pill } from '@ticketswap/solar'
import styled from '@emotion/styled'
import { decodeGlobalId } from '~/utils/id'
import { RouteMap } from '~/lib/routeMap'
import Link from 'next/link'
import { getEventDescription } from '~/utils/eventDescription'
import { Ticket } from '@ticketswap/solar/icons'
import useLanguage from '~/hooks/useLanguage'
import ViewportTracking from '~/components/ViewportTracking'
import { EXPLORE_NEARBY_EVENT_TAPPED, EXPLORE_NEARBY_EVENT_VIEWED } from '~/lib/tracking-events'
import { track } from '~/utils/analytics'

const EventsGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${space[8]};
  margin-block-start: ${space[16]};

  @media ${device.tablet} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

const NearbyEvents = ({ loading, events }) => {
  const { language } = useLanguage()

  const handleTracking = async event =>
    await track(EXPLORE_NEARBY_EVENT_TAPPED, {
      event,
    })

  if (loading)
    return (
      <EventsGrid>
        <Skeleton />
      </EventsGrid>
    )

  return (
    <ViewportTracking
      event={EXPLORE_NEARBY_EVENT_VIEWED}
      payload={{
        events,
      }}
    >
      <EventsGrid>
        {events.map(event => (
          <Link
            passHref
            key={event.id}
            prefetch={false}
            href={{
              pathname: RouteMap['EVENT_PAGE'],
              query: {
                eventIdOrEventTypeSlug: decodeGlobalId(event.id),
                eventSlug: event.slug,
              },
            }}
          >
            <button as="a" onClick={() => handleTracking(event)}>
              <Card
                title={event.name}
                subtitle={getEventDescription(event, language)}
                rightAdornment={
                  <Pill
                    variant={event?.availableTicketsCount > 0 ? 'primary' : 'disabled'}
                    leftAdornment={<Ticket size={16} />}
                  >
                    {event?.availableTicketsCount}
                  </Pill>
                }
              />
            </button>
          </Link>
        ))}
      </EventsGrid>
    </ViewportTracking>
  )
}

export default NearbyEvents
